import { useLayoutEffect } from "react";
import type { CSSProperties, ReactNode } from "react";
import { Link, Outlet, ScrollRestoration } from "react-router";
import { EmptyState, Toasts } from "@fortex/map";
import type { IconName } from "@fortex/map";
import { AppBar } from "./AppMenu";
import { useApp } from "./context";

export function Shell() {
  const { theme, config, labels } = useApp();

  useLayoutEffect(() => {
    document.title = labels.appTitle;
  }, [labels]);

  return (
    <div className="fxmap fxapp" data-fxmap="app-shell" data-theme={theme} style={config.accent ? ({ "--fxmap-accent": config.accent } as CSSProperties) : undefined}>
      <main className="fxapp-main" id="fxapp-content">
        <Outlet />
      </main>
      <div className="fxapp-toasts">
        <Toasts />
      </div>
      <ScrollRestoration />
    </div>
  );
}

export function PageFrame({ title, icon = null, narrow = false, children }: { title: string; icon?: IconName | null; narrow?: boolean; children: ReactNode }) {
  return (
    <div className="fxapp-frame" data-fxmap="page-frame">
      <AppBar title={title} icon={icon} />
      <div className={["fxapp-page", narrow ? "fxapp-page-narrow" : ""].filter(Boolean).join(" ")}>{children}</div>
    </div>
  );
}

export function NotFoundPage() {
  const { labels } = useApp();

  return (
    <PageFrame title={labels.notFoundTitle} narrow>
      <EmptyState icon="warning" title={labels.notFoundTitle} action={<Link to="/">{labels.goHome}</Link>} />
    </PageFrame>
  );
}
